<template>
	<div>
		<new-yb-line-item
				:action="this.newLineItemAction.NEW"
				v-if="createNewLineItemModal"
				v-model="showNewLineItemModal"
				:ndc-number="ndcNumber"
				:container-id="record.fieldData['Container ID']"
				:initial-percent-fill="1"
				:initial-pack-size="record.fieldData['ZIPackage Size']"
        :initial-schedule=this.schedule
		></new-yb-line-item>
		<b-modal v-model="showExportModal" ok-title="Close" ok-only>
			<div class="text-center">
				<a v-if="exportModalFileType === 'xlsx'" :href="exportModalUrl" target="_blank"
				   :download="exportModalFileName">Download File</a>
				<a v-else :href="exportModalUrl" target="_blank" :download="exportModalFileName">Download File</a>
			</div>
		</b-modal>
		<div class="row">
			<ul class="col-12 nav justify-content-end">
				<li class="nav-item"><a href="" @click.prevent="exportToExcel">Export to Excel
					<font-awesome-icon class="ml-1" icon="file-excel"></font-awesome-icon>
				</a></li>
				<li class="nav-item pl-3"><a href="" @click.prevent="saveAsPdf">Save as PDF
					<font-awesome-icon class="ml-1" icon="file-pdf"></font-awesome-icon>
				</a></li>
			</ul>
		</div>
		<div class="card pb-3">
			<vue-headful
					:title="title">
			</vue-headful>
			<b-modal
					:ok-title="'Move'"
					:cancel-title="'Cancel'"
					v-model="showMoveModal"
					v-if="showMoveModal"
					:ok-disabled="!selectedJob"
					@ok="moveContainer"
					width="600"
			>
				<template #modal-title>
					<h5>Move Container</h5>
					<span>Select A Destination Job</span>
				</template>
				<MoveJobList
						:registration="record.fieldData['hcn.job.reg::Registration Number']"
				></MoveJobList>
			</b-modal>
			<b-modal v-model="showAddModal" v-if="showAddModal" @ok="addLineItem"
					 :ok-disabled="!ndcNumber || ndcNumber.length === 0">
				<template #modal-title><h5>Add Line Item</h5></template>
				<span>Select an NDC Number</span>
				<NDCSelect2
            v-model="ndcNumber"
            @schedule="schedule = $event"
            :registration="record.fieldData['hcn.job.reg::Registration Number']"
        ></NDCSelect2>
			</b-modal>
			<b-modal :ok-title="'Yes'" :cancel-title="'No'" v-model="showDeleteModal" v-if="showDeleteModal"
					 @ok="deleteContainer">
				<span slot="header">
					<h3>Delete Yellow Bucket</h3>
				</span>
				Are you sure you want to delete this container and its related line items?
			</b-modal>
			<b-modal :ok-title="'Yes'" :cancel-title="'No'" v-model="showLockModal" v-if="showLockModal"
					 @ok="lockContainer">
				<template #modal-title></template>
				Are you sure you want to lock this container and its related line items?
			</b-modal>
			<b-modal :ok-title="'Yes'" :cancel-title="'No'" v-model="showUnlockModal" v-if="showUnlockModal"
					 @ok="unlockContainer">
				<template #modal-title></template>
				Are you sure you want to unlock this container and its related line items?
			</b-modal>
			<div class="card-body">
				<div class="card-title">
					<div class="row">
						<h5 v-if="!parentLocked && (accessPrivileges.includes('UNLOCK_CONTAINER') || accessPrivileges.includes('LOCK_CONTAINER'))"
							class="col-4">
							<a v-if="accessPrivileges.includes('UNLOCK_CONTAINER') && locked" href="#"
							   @click.prevent="confirmUnlockContainer">
								<font-awesome-icon style="margin-right: 0.5em;" icon="lock"></font-awesome-icon>
							</a>
							<a v-else-if="accessPrivileges.includes('LOCK_CONTAINER')" href="#"
							   @click.prevent="confirmLockContainer">
								<font-awesome-icon style="margin-right: 0.5em;" icon="lock-open"></font-awesome-icon>
							</a>
							<strong>Yellow Bucket Container {{ record.fieldData['Container ID'] }}</strong>
						</h5>
						<h5 v-else class="col-4">
							<span v-if="locked">
								<font-awesome-icon style="margin-right: 0.5em;" icon="lock"></font-awesome-icon>
							</span>
							<span v-else>
								<font-awesome-icon style="margin-right: 0.5em;" icon="lock-open"></font-awesome-icon>
							</span>
							<strong>Yellow Bucket Container {{ record.fieldData['Container ID'] }}</strong>
						</h5>
						<h5 class="col-8">
							<div class="float-right"><strong>Container Name {{
									record.fieldData['Container Name']
								}}</strong></div>
						</h5>
					</div>
					<FeedbackPanel></FeedbackPanel>
					<div class="row">
						<ul v-show="!locked" class="nav col-12 justify-content-end">
							<li v-show="accessPrivileges.includes('MOVE_CONTAINER') && !locked" class="nav-item mr-3">
								<a href="" @click.prevent="showMoveLineItem">Move Container
									<font-awesome-icon class="ml-1" icon="dolly"></font-awesome-icon>
								</a>
							</li>
							<li v-show="accessPrivileges.includes('DELETE_CONTAINER') && !locked" class="nav-item"><a
									href="" @click.prevent="confirmDeleteContainer">Delete Container
								<font-awesome-icon class="ml-1" icon="times-circle"></font-awesome-icon>
							</a></li>
						</ul>
					</div>
				</div>
				<div class="row">
					<div class="col-12">
						<div class="card mb-3">
							<div class="card-body">
								<div class="row">
									<div class="col-2">
										<div><strong>Company ID</strong></div>
										<div class="job-field">{{ record.fieldData['Company::Company_PK_ID'] }}</div>
									</div>
									<div class="col-2">
										<div><strong>Company Name</strong></div>
										<div class="job-field">{{ record.fieldData['Company::Company Name'] }}</div>
									</div>
									<div class="col-2">
										<div><strong>Registration</strong></div>
										<div class="job-field">{{
												record.fieldData['hcn.job.reg::Registration Number']
											}}
										</div>
									</div>
									<div class="col-2">
										<div><strong>Activity</strong></div>
										<div class="job-field">{{ record.fieldData['hcn.job.reg::Activity'] }}</div>
									</div>
									<div class="col-2">
										<div><strong>Job ID</strong></div>
										<router-link
												:to="{name: 'job-view', params: {id: parentRecordId}}">
											{{ record.fieldData['Job ID'] }}
										</router-link>
									</div>
									<div class="col-2">
										<div><strong>Job Name</strong></div>
										<div class="job-field">{{ record.fieldData['Job::Job Name'] }}</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<router-view
							:record="record"
							:record-id="recordId"
							:locked="locked"
							:entity="'yb-container'"
							@update-record="updateRecord"
							@set-edit-mode="setEditMode"
					></router-view>
					<div class="col-lg-9 col-sm-12">
						<div class="card">
							<div class="card-header pt-2 pb-2">
								<span>Line Items</span>
								<span class="float-right">
									<a href="#"
									   v-if="accessPrivileges.includes('CREATE_LINE_ITEM') && !locked && !expired"
									   @click="selectNdcOnAddItem">
									Add Line Item <font-awesome-icon icon="plus-circle"></font-awesome-icon>
								</a>
								</span>
							</div>
							<div class="card-body pt-1">
								<div class="pb-1">
									<span class="small" style="display: inline-block;">
										Show
									</span>
									<b-form-select
											v-model="itemRowsPerPage"
											:options="rowsPerPageOptions"
											size="sm"
											style="width: auto; display: inline-block;"
											class="mr-2 ml-2"
											plain
									></b-form-select>
									<span class="small" style="display: inline-block;">
										entries
									</span>
								</div>
								<b-table
										:fields="itemTableFields"
										:items="record.portalData.li"
										:per-page="itemRowsPerPage"
										:current-page="itemPage"
										small
										responsive
										hover
										id="item-table"
								>
									<template v-slot:head(locked)="data">
											<span style="margin-right: 0.25em;">
												<font-awesome-icon icon="lock"></font-awesome-icon>
											</span>
									</template>
									<template v-slot:cell(locked)="data">
											<span style="margin-right: 0.25em;">
												<span v-if="data.item['hcn.holding_li_SHOWCN::Locked Container Line Item'] === 'Yes'"><font-awesome-icon
														icon="lock"></font-awesome-icon></span>
											</span>
									</template>
									<template v-slot:cell(view)="data">
										<router-link
												:to="{name: 'yb-line-item-view', params: {id: data.item.recordId}}">
											<font-awesome-icon icon="eye"></font-awesome-icon>
										</router-link>
									</template>
								</b-table>
								<div style="font-size: smaller; float: left; top: 0.5em; position: relative;">
									Showing
									{{
										itemMaxRows === 0 ? 0 : itemRowsPerPage
												* (itemPage - 1) + 1
									}} to {{
										Math.min(itemRowsPerPage * itemPage,
												itemMaxRows)
									}} of
									{{ itemMaxRows }} entries
								</div>
								<b-pagination
										size="sm"
										:total-rows="itemMaxRows"
										:per-page="itemRowsPerPage"
										v-model="itemPage"
										align="right"
								></b-pagination>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import feedbackMixin from '../mixins/feedback'
import detailViewMixin from '../mixins/detail-view'
import newLineItemActionMixin from '../mixins/new-line-item-action'
import PortalGrid from '../components/PortalGrid'
import FeedbackPanel from '../components/FeedbackPanel';
import DatePicker from '../components/DatePicker'

import Vue from 'vue'
import VueMoment from 'vue-moment'
import moment from 'moment'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Modal from "../components/Modal";
import NDCSelect2 from "../components/NDCSelect2";
import exportFileMixin from "../mixins/export-file";
import MoveJobList from "./container/MoveJobList";
import {EventBus} from "@/event-bus";
import NewYbLineItem from "@/components/NewYBLineItem";

Vue.use(VueAxios, axios);

Vue.use(VueMoment, {
	moment
});

export default {
	name: "YellowBucket",
	mixins: [feedbackMixin, detailViewMixin, exportFileMixin, newLineItemActionMixin],
	components: {NewYbLineItem, MoveJobList, NDCSelect2, Modal, DatePicker, FeedbackPanel, PortalGrid},
	mounted() {
		let vm = this
		EventBus.$on('line-item-created', this.onLineItemCreated)
		EventBus.$on('container-edited', this.editRecord)
		EventBus.$on('job-selected', function (job) {
			vm.selectedJob = job.job_id
		})
	},
	destroyed() {
		EventBus.$off('container-edited', this.editRecord)
		EventBus.$off('job-selected')
	},
	computed: {
		parentRecordId: function () {
			return this.record.fieldData['Job::Record_ID'] ? this.record.fieldData['Job::Record_ID'].toString() : '0'
		},
		expired: function () {
			let expDateString = this.record.fieldData['hcn.job.reg::Expiration Date'];
			let expDate = moment(expDateString, 'MM/DD/YYYY');
			let now = moment().startOf('day');
			return expDate.isBefore(now)
		},
		locked: function () {
			return this.record.fieldData['Locked Container'] && this.record.fieldData['Locked Container'].toUpperCase() === 'YES' ||
				this.parentLocked;
		},
		parentLocked: function () {
			return this.record.fieldData['Job::Locked Job'] && this.record.fieldData['Job::Locked Job'].toUpperCase() === 'YES';
		},
		itemMaxRows: function () {
			if (this.record.portalData['li']) {
				let length = this.record.portalData['li'].length;
				console.log('Max rows ' + length);
				return length
			} else {
				return 50
			}
		},
		title: function () {
			return this.record.fieldData['Container Name']
		}
	},
	methods: {
		onLineItemCreated(event) {
			console.log('Yellow bucket line item created')
			this.$router.push({path: `/yb-line-item/${event.recordId}`})
		},
		moveContainer: function () {
			console.log('Moving yellow bucket container to selected job ' + this.selectedJob);
			if (this.selectedJob.length > 0) {
				this.getRecord(this.recordId, [{
					name: '3DS_Move_YB_Container',
					param: this.selectedJob
				}])
					.then(value => {
						this.record = value.data.response.data[0]
					})
					.catch(reason => {
						console.log('An error occurred while moving a yellow bucket container');
						this.showMoveModal = false;
						this.authCheck(reason)
					})
					.finally(() => {
						this.showMoveModal = false;
						this.show = false;
						console.log(this.selectedJob)
					})
			}
		},
		showMoveLineItem: function () {
			this.showMoveModal = true
		},
		exportToExcel: function () {
			let quickFind = false;
			let searchCriteria = [{"Container ID": '==' + this.record.fieldData['Container ID']}];
			let restEntity = 'yb-line-items';
			this.exportFile(searchCriteria, quickFind, restEntity, 'xlsx')
		},
		saveAsPdf: function () {
			let quickFind = false;
			let searchCriteria = [{"Container ID": '==' + this.record.fieldData['Container ID']}];
			let restEntity = 'yb-line-items';
			this.exportFile(searchCriteria, quickFind, restEntity)
		},
		lockContainer: function () {
			this.show = true;
			let vm = this;
			let recordId = this.recordId;
			this.axios.patch(`/3ds/api/yb-container/lock/${recordId}`)
				.then(value => {
					console.log('Successfully locked yellow bucket container with record ID ' + recordId)
					console.log(JSON.stringify(value))
					this.getRecord(recordId)
						.then(value => {
							this.record = value.data.data[0]
						})
						.catch(reason => {
							console.error('An error occurred while retrieving a yellow bucket container with record ID ' + recordId);
							console.error(JSON.stringify(reason));
						})
				})
				.catch(reason => {
					console.error('Failed to lock yellow bucket container with record ID ' + recordId)
					console.error(JSON.stringify(reason))
				})
				.finally(() => {
					vm.showLockModal = false;
					this.show = false
				})
		},
		unlockContainer: function () {
			this.show = true;
			let vm = this;
			let recordId = this.recordId;
			this.axios.patch(`/3ds/api/yb-container/unlock/${recordId}`)
				.then(value => {
					console.log('Successfully unlocked yellow bucket container with record ID ' + recordId)
					console.log(JSON.stringify(value))
					this.getRecord(recordId)
						.then(value => {
							this.record = value.data.data[0]
						})
						.catch(reason => {
							console.error('An error occurred while retrieving a yellow bucket container with record ID ' + recordId);
							console.error(JSON.stringify(reason));
						})
				})
				.catch(reason => {
					console.error('Failed to unlock yellow bucket container with record ID ' + recordId)
					console.error(JSON.stringify(reason))
				})
				.finally(() => {
					vm.showUnlockModal = false;
					this.show = false
				})
		},
		deleteContainer: function () {
			let vm = this;
			let parentRecordId = vm.record.fieldData['Job::Record_ID'];
			let recordId = this.recordId;
			this.deleteRecord(recordId)
				.then(value => {
					console.log('Successfully deleted yellow bucket container with record ID ' + recordId)
					console.log(JSON.stringify(value))
					vm.$router.push({name: 'job-view', params: {id: parentRecordId.toString()}})
				})
				.catch(reason => {
					console.error('Failed to delete yellow bucket container with record ID ' + recordId);
					console.error(JSON.stringify(reason))
				})
				.finally(() => {
					vm.showDeleteModal = false
				})
		},
		confirmLockContainer: function () {
			this.showLockModal = true
		},
		confirmUnlockContainer: function () {
			if (!this.parentLocked) {
				this.showUnlockModal = true
			}
		},
		confirmDeleteContainer: function () {
			this.showDeleteModal = true
		},
		selectNdcOnAddItem: function () {
			this.showAddModal = true
		},
		addLineItem: function () {
			this.showAddModal = false
			this.createNewLineItemModal = true
			this.showNewLineItemModal = true
			/*Vue.axios.post('/3ds/api/yb-line-item',
				{
					fieldData: {
						"NDC Number": this.ndcNumber,
						// id_company: this.record.fieldData['Company::Company_PK_ID'],
						// id_Job: this.record.fieldData['Company::Job ID'],
						"Container ID": this.record.fieldData['Container ID'],
					},

				},
				{
					headers: {
						'Authorization': 'Bearer ' + this.token
					}
				}
			)
				.then(value => {
					this.$router.push({
						name: 'yb-line-item-edit',
						params: {
							id: value.data.recordId
						}
					})
				})
				.catch(reason => {
					this.authCheck(reason)
				})*/
		}
	},
	data() {
		return {
			createNewLineItemModal: false,
			showNewLineItemModal: false,
			showMoveModal: false,
			selectedJob: '',
			restEntity: 'yb-container',
			restViewEntity: 'yb-container-view',
			portals: [
				{
					name: 'li',
					limit: 1000,
				}
			],
			itemPortalName: 'hcn.holding_li_SHOWCN',
			itemTitle: 'Line Items',
			itemRestDetailEntity: 'yb-line-item-view',
			itemFooter: true,
			itemHeader: true,
			itemHasLockedColumn: true,
			itemPage: 1,
			itemRowsPerPage: 10,
			itemTableFields: [
				{
					key: 'locked',
					label: '',
					sortable: true,
					thStyle: {
						width: '35px'
					}
				},
				{
					key: 'view',
					label: ' ',
					thStyle: {
						width: '35px'
					}
				},
				{
					key: 'hcn.holding_li_SHOWCN::NDC Number',
					label: 'NDC',
					sortable: true
				},
				{
					key: 'hcn.holding_li_SHOWCN_danox_dic::CSA Schedule LU',
					label: 'CSS',
					sortable: true
				},
				{
					key: 'hcn.holding_li_SHOWCN::NDC Description',
					label: 'Description',
					sortable: true
				},
				{
					key: 'hcn.holding_li_SHOWCN::Form 222 Number',
					label: 'Form 222#',
					sortable: true
				},
				{
					key: 'hcn.holding_li_SHOWCN::Container Line Item ID',
					label: 'ID',
					sortable: true
				}
			],
			showAddModal: false,
			showDeleteModal: false,
			showLockModal: false,
			showUnlockModal: false,
			ndcNumber: '',
      schedule: '',
			rowsPerPageOptions: [
				{
					value: 10,
					text: '10'
				},
				{
					value: 25,
					text: '25'
				},
				{
					value: 50,
					text: '50'
				},
				{
					value: 100,
					text: '100'
				},
			]
		}
	}
}
</script>

<style scoped>
</style>